export default "__VITE_ASSET__ffa4cf9c__"